import Rebilly from './rebilly';
import modules from './modules';

export default new Rebilly({modules});



// WEBPACK FOOTER //
// ./src/index.js